module.exports = __webpack_public_path__ + "img/avalon-20.ff0f3098.jpg";